import SubscribeButton from './SubscribeButton';

export default SubscribeButton;
